module.exports = __webpack_public_path__ + "static/media/facebook_inverted.b0000111.svg";